import React from 'react';
import { LinkTo } from '../LinkTo';

var BlogPagination = function BlogPagination(_ref) {
  var previous = _ref.previous,
      next = _ref.next;
  return /*#__PURE__*/React.createElement("div", {
    className: "pagination"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, previous && /*#__PURE__*/React.createElement(LinkTo, {
    type: "route",
    className: "pagination-button pagination-back-button",
    url: previous
  }, "Older"), next && /*#__PURE__*/React.createElement(LinkTo, {
    type: "route",
    className: "pagination-button pagination-back-button",
    url: next
  }, "Newer")));
};

export default BlogPagination;
BlogPagination.displayName = 'BlogPagination';
var BlogPaginationDoc;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  BlogPaginationDoc = require('./doc').doc(BlogPagination);
}

var BlogPaginationWrapper = BlogPaginationDoc || BlogPagination;
export { BlogPaginationWrapper as BlogPagination };